import { useState, useEffect } from 'react';
import isEqual from 'lodash/isEqual';

export function updateQueryParams(params) {
  if (history.pushState) {
    Object.keys(params).forEach(
      key => (params[key] == null || params[key] == '') && delete params[key]
    );

    const query = new URLSearchParams();

    Object.keys(params).forEach(key => {
      query.append(key, params[key]);
    });

    let newurl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname;

    if (query) {
      newurl += `?${query}`;
    }

    window.history.pushState({ path: newurl }, '', newurl);
    window.dispatchEvent(
      new CustomEvent('popstate', { state: { path: newurl } })
    );
  }
}

export function getQueryFilter(state = {}) {
  const params = new URLSearchParams(location.search);
  const filter = {};

  function toArray(value) {
    return value.split(',').map(value => {
      if (isNaN(value)) return value;
      return parseFloat(value);
    });
  }

  for (const [key, value] of params) {
    switch (true) {
      case Array.isArray(state[key]):
        filter[key] = toArray(value);
        break;
      case value === 'true':
      case value === 'false':
        filter[key] = value === 'true';
        break;

      case !isNaN(parseFloat(value)) && isFinite(value):
        filter[key] = parseFloat(value);
        break;

      default:
        filter[key] = value;
        break;
    }
  }

  return filter;
}

export function useQueryState(defaultState = {}) {
  const query = getQueryFilter(defaultState);

  const [filter, setFilter] = useState({
    ...defaultState,
    ...query,
  });

  const onStateChange = () => {
    const query = getQueryFilter(defaultState);
    setFilter({
      ...defaultState,
      ...query,
    });
  };

  useEffect(() => {
    window.addEventListener('popstate', onStateChange);

    return function cleanup() {
      window.removeEventListener('popstate', onStateChange);
    };
  });

  const updateQueryState = args => {
    let state = args;
    if (typeof state === 'function') {
      state = state({
        ...defaultState,
        ...query,
      });
    }

    let params = {};

    Object.keys(state).forEach(key => {
      if (state[key] && !isEqual(state[key], defaultState[key])) {
        params[key] = state[key];
      }
    });

    updateQueryParams(params);
  };

  return [{ ...filter }, updateQueryState];
}

export default {
  updateQueryParams,
  getQueryFilter,
  useQueryState,
};
